import { render } from "./UserManage.vue?vue&type=template&id=b0bba26c&scoped=true"
import script from "./UserManage.vue?vue&type=script&lang=js"
export * from "./UserManage.vue?vue&type=script&lang=js"

import "./UserManage.vue?vue&type=style&index=0&id=b0bba26c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0bba26c"]])

export default __exports__